<script setup>
import ChevronSvg from '@svg/new-chevron.svg'

defineProps({
    meta: Object,
})

const emit = defineEmits()
</script>

<template>
    <div class="flex items-center space-x-0.5">
        <button v-on:click="link.url ? emit('navigated', link.url) : null" v-for="link in meta.links" :key="link.label" class="rounded-2xl flex items-center justify-center size-8 sm:size-9 text-sm" :class="{ 'text-[rgba(233,232,255,1)] bg-[rgba(107,96,255,1)] leading-none font-semibold': link.active, 'bg-[rgba(20,22,57,1)] text-[rgba(132,156,241,1)]': !link.active, 'hidden': !link.url }">
            <div v-if="link.label === 'next'" :class="{ 'opacity-20': meta.current_page === meta.total_pages }">
                <span class="sr-only">Next</span>
                <ChevronSvg class="flex-shrink-0 size-6 -rotate-90 text-[rgba(132,156,241,1)]" />
            </div>
            <div v-else-if="link.label === 'previous'">
                <span class="sr-only">Previous</span>
                <ChevronSvg class="flex-shrink-0 size-6 rotate-90 text-[rgba(132,156,241,1)]" />
            </div>
            <span v-else>{{ link.label }}</span>
        </button>
    </div>
</template>
